/** Kurzstand für Integrationskachel und DATEV-Seite: was bereit ist, was hakt, wann zuletzt exportiert. */
export type DatevOverview = {
  ready: number;
  failing: number;
  lastExportAt: string | null;
};

async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url, { credentials: 'include' });
  const d = await res.json().catch(() => null);
  if (!res.ok) throw new Error(d?.error || 'Anfrage fehlgeschlagen.');
  return d as T;
}

function today(): string {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Zählt alle offenen Rechnungen ab „Übergabe ab“. Ohne dieses Datum gibt es noch nichts zu zählen. */
export async function loadDatevOverview(transferFrom: string | null): Promise<DatevOverview> {
  const [preview, exports] = await Promise.all([
    transferFrom && transferFrom <= today()
      ? getJson<{ candidates: Array<{ errors: string[] }> }>(`/api/datev/export/preview?from=${transferFrom}&to=${today()}`)
      : Promise.resolve({ candidates: [] }),
    getJson<{ batches: Array<{ createdAt: string; status: string }> }>('/api/datev/exports'),
  ]);
  const active = exports.batches.filter((batch) => batch.status !== 'reverted');
  return {
    ready: preview.candidates.filter((c) => c.errors.length === 0).length,
    failing: preview.candidates.filter((c) => c.errors.length > 0).length,
    lastExportAt: active[0]?.createdAt ?? null,
  };
}
